import React from 'react';

/**
 * Badge - Etichetta/tag riutilizzabile
 * 
 * Props:
 * - variant: 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info'
 * - size: 'sm' | 'md'
 * - dot: boolean (mostra pallino colorato)
 */
function Badge({
  children,
  variant = 'default',
  size = 'md',
  dot = false,
  className = ''
}) {
  const variantClasses = {
    default: 'bg-gray-100 text-gray-800',
    primary: 'bg-primary-100 text-primary-800',
    success: 'bg-green-100 text-green-800',
    warning: 'bg-yellow-100 text-yellow-800',
    danger: 'bg-red-100 text-red-800',
    info: 'bg-blue-100 text-blue-800'
  };

  const dotColors = {
    default: 'bg-gray-400',
    primary: 'bg-primary-400',
    success: 'bg-green-400',
    warning: 'bg-yellow-400',
    danger: 'bg-red-400',
    info: 'bg-blue-400'
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm'
  };

  return (
    <span
      className={`
        inline-flex items-center gap-1.5 font-medium rounded-full
        ${variantClasses[variant]}
        ${sizeClasses[size]}
        ${className}
      `}
    >
      {dot && (
        <span className={`w-1.5 h-1.5 rounded-full ${dotColors[variant]}`} />
      )}
      {children}
    </span>
  );
}

/**
 * StatusBadge - Badge per stati comuni
 */
export function StatusBadge({ status }) {
  const statusConfig = {
    attivo: { variant: 'success', label: 'Attivo' },
    inattivo: { variant: 'default', label: 'Inattivo' },
    in_corso: { variant: 'info', label: 'In corso' },
    completato: { variant: 'success', label: 'Completato' },
    scaduto: { variant: 'danger', label: 'Scaduto' },
    in_scadenza: { variant: 'warning', label: 'In scadenza' },
    programmato: { variant: 'primary', label: 'Programmato' },
    annullato: { variant: 'default', label: 'Annullato' },
    pending: { variant: 'warning', label: 'In attesa' },
    approvato: { variant: 'success', label: 'Approvato' },
    rifiutato: { variant: 'danger', label: 'Rifiutato' }
  };

  const config = statusConfig[status?.toLowerCase()] || {
    variant: 'default',
    label: status || 'N/D'
  };

  return (
    <Badge variant={config.variant} dot>
      {config.label}
    </Badge>
  );
}

export default Badge;
